export default __webpack_public_path__ + "atomic/_patterns/01-atoms/primary-menu-link/_primary-menu-link.twig";